/** Stable reference identity; label is a human-readable snapshot, never the lookup key. */
export interface IInputReference { id: string; label: string; }
export type TReferencePart = { type: 'text'; text: string } | { type: 'reference'; id: string; label: string };
export type TReferenceContent = TReferencePart[];
export type TReferenceSearch = (query: string, signal: AbortSignal) => Promise<IInputReference[]>;

export const referenceText = (content: TReferenceContent): string =>
  content.map(part => part.type === 'text' ? part.text : part.label).join('');
